module.exports = __webpack_public_path__ + "LPF to FSA Conversion.pdf";